import { TextField } from "@mui/material"
import { useState } from "react"
import ShowIcon from '@mui/icons-material/Visibility';
import HideIcon from '@mui/icons-material/VisibilityOff';
import { txt } from "../../services/translation";

export default function Password({value, onChange, label, error, InputLabelProps, helperText}){

    const [show, setShow] =  useState(false)

    return <TextField
        label={label || txt('password')}
        name='password'
        type={show ? 'text' : 'password'}
        size='small'
        value={value}
        onChange={onChange}
        InputProps={{
            inputProps: {
                minLength: 8,
                maxLength: 200,
            },
            endAdornment: show ? 
                <HideIcon sx={{cursor: 'pointer'}} onClick={() => setShow(false)} color='action'/> :
                <ShowIcon sx={{cursor: 'pointer'}} onClick={() => setShow(true)} color='action'/>
        }}
        fullWidth
        required
        error={error ? true : false}
        helperText={error || (helperText || '')}
        InputLabelProps={InputLabelProps}
    />
}